<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex burger-spacing align-items-start justify-content-between">
        <back-arrow :title="user.tostring" :route-back="'UserIndex'"/>
        <show-actions
          :resetPassword=allowResetPassword
          :editItem=allowEdit
          :deleteItem=allowDelete
          @clickOnResetPasswordBtn="clickOnResetPasswordBtn"
          @clickOnEditBtn="clickOnEditBtn"
          @clickOnDeleteBtn="clickOnDeleteBtn">
        </show-actions>
      </div>

      <div class="row">
        <div class="col-md-12">
          <b-card class="mt-2 mb-4 shadow-sm">
            <div class="row">

              <div class="col-12 col-md-6 col-lg-6 mb-5">
                <show-value-field
                  :object="user"
                  :label="$t('user.Firstname')"
                  :property="'firstname'">
                </show-value-field>
              </div>

              <div class="col-12 col-md-6 col-lg-6 mb-5">
                <show-value-field
                  :object="user"
                  :label="$t('user.Lastname')"
                  :property="'lastname'">
                </show-value-field>
              </div>

              <div class="col-12 col-md-6 col-lg-6 mb-5">
                <show-value-field
                  :object="user"
                  :label="$t('user.Username')"
                  :property="'username'">
                </show-value-field>
              </div>

              <div class="col-12 col-md-6 col-lg-6 mb-5">
                <show-value-field
                  :object="user"
                  :label="$t('user.PhoneNumber')"
                  :property="'phoneNumber'">
                </show-value-field>
              </div>

              <div class="col-12 col-md-6 col-lg-6 mb-5">
                <show-value-field
                  :object="user"
                  :label="$t('Role')"
                  :property="'role'"
                  :need-translation="true">
                </show-value-field>
              </div>

              <!-- commission -->
              <div class="col-12 col-md-6 col-lg-6 mb-5" v-if="user && user.role === 'ROLE_COMMISSION'">
                <show-value-field
                  :object="user.commission"
                  :label="$t('Commission')"
                  :property="'tostring'">
                </show-value-field>
              </div>

            </div>
          </b-card>
        </div>

      </div>

    </b-container>

    <!-- Modal Delete -->
    <Item-delete-modal
      :itemSingularName="'user'"
      :beginsWithVoyel="true"
      :selectedItem="user"
      :selectedItemSpecialString="user ? user.username : null"
      controllerName="user"
      itemSingularNameUpp="User"
      @didDeleteItem="didDeleteUser()">
    </Item-delete-modal>


  </div>
</template>

<script>

import api from '../../services/api'
import BackArrow from '../../components/b122/BackArrow'
import ShowActions from '../../components/b122/ShowActions'
import ItemDeleteModal from "../../components/b122/ItemDeleteModal.vue";
import ShowArrayValueField from "../../components/b122/showFields/ShowArrayValueField.vue";
import ShowValueField from "../../components/b122/showFields/ShowValueField.vue";

export default {

  name: 'UserShow',

  components: {
    ShowValueField,
    ShowArrayValueField,
    ItemDeleteModal,
    BackArrow,
    ShowActions,
  },

  data () {
    return {
      allowDelete: false,
      allowResetPassword: true,
      allowEdit: true,
      userId: this.$route.params.userId,
      user: {}
    }
  },

  computed: {
    getValue () {
      return property => (this.user[property] || this.user[property] === false) ? this.user[property] : 'N/A'
    },

    getValueArray () {
      return property => (this.user[property] && this.user[property].length) ? this.user[property].map(el => el.tostring).join(', ') : 'N/A'
    }

  },

  mounted () {
    this.fetchData()
  },

  methods: {
    fetchData () {
      this.fetchUser()
    },

    fetchUser () {
      api
        .get(`/user/${this.userId}`)
        .then(response => {
          this.user = response.data
          this.allowDelete = this.user.role !== 'ROLE_SUPER_ADMIN'
        })
        .catch((error) => {
          this.$router.push({
            name: 'UserIndex',
            params: {
              message: error.response.data.message
            }
          })
        })
    },

    clickOnResetPasswordBtn () {
      const formData = new FormData()
      formData.append('username', this.user.username)

      api({
        method: 'POST',
        url: `/forgotPassword/sendResetPasswordMail`,
        data: formData
      })
        .then(() => {
          this.successToast(this.$i18n.t('Reset.password.mail.sent') + ' "' + this.user.username + '" ')
        })
    },

    clickOnEditBtn () {
      this.$router.push({
        name: 'UserEdit',
        params: {
          userId: this.user.id
        }
      })
    },

    clickOnDeleteBtn () {
      this.$bvModal.show('item-delete-modal')
    },

    didDeleteUser () {
      this.$router.push({
        name: 'UserIndex'
      })
    },

    successToast (message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    }

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/user/UserShow.vue